import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import CommonImages from '../../../commons/images';
import SubscriberCounter from '../subscriberCounter';
import * as styles from './styles';

function ColourWord() {
    return (
        <Box component="span" sx={styles.colourWordStyle}>colour.</Box>
    );
}

function AnimatedBars() {
    return (
        <Box aria-hidden="true" sx={styles.barsWrapper}>
            <Box
                component="img"
                src={CommonImages.ECAL_ANIMATED_BARS}
                alt=""
                sx={styles.animatedBarsImage}
            />
        </Box>
    );
}

function Hero({ onBrowse, onWhatsHot, totalSubscribers, totalSubscribersLoading }) {
    return (
        <Box component="section" sx={styles.section}>
            <AnimatedBars />

            <Container maxWidth="xl" sx={styles.container}>

                <SubscriberCounter totalSubscribers={totalSubscribers} loading={totalSubscribersLoading} />

                <Typography variant="overline" sx={styles.eyebrow}>
                    The official calendar of the world's best brands
                </Typography>

                <Typography variant="h1" sx={styles.headline}>
                    Live your life in{' '}
                    <ColourWord />
                </Typography>

                <Box sx={styles.subheadingBox}>
                    <Typography variant="body1" sx={styles.subheadingMobile}>
                        Transform your calendar into an exciting lineup of the moments you
                        love—100% free. As the <strong>official and exclusive</strong> calendar provider for the worldʼs best
                        sports, entertainment, and lifestyle brands, ECAL syncs real-time event
                        updates, ticket links, broadcast details, streaming links and more directly to your calendar in full
                        colour. Discover your favourite brands and sync in seconds, or log in to <strong>Manage
                        My ECAL</strong> to customise your personal feed.
                    </Typography>
                    <Typography variant="body1" sx={styles.subheadingDesktop}>
                        Transform your daily calendar into an exciting lineup of the moments you love — completely free.
                    </Typography>
                    <Typography variant="body1" sx={styles.subheadingDesktop}>
                        ECAL is the <strong>official and exclusive</strong> digital calendar provider for the worldʼs
                        best sports, entertainment, and lifestyle brands, delivering live, automatic
                        updates directly to your personal calendar. Never miss a kickoff, concert, or
                        drop with real-time event updates, direct ticketing links, broadcast details,
                        streaming links and more, synced seamlessly in full colour.
                    </Typography>
                    <Typography variant="body1" sx={styles.subheadingDesktop}>
                        Discover your favourite brands and sync in seconds, or log in to <strong>Manage My ECAL</strong> to curate your ultimate calendar.
                    </Typography>
                </Box>

                <Box sx={styles.ctaRow}>
                    <Button variant="contained" size="large" onClick={onBrowse} sx={{ width: { xs: '100%', md: 'auto' } }}>
                        Browse publishers
                    </Button>

                    <Box sx={styles.whatsHotWrapper}>
                        <Button
                            onClick={onWhatsHot}
                            startIcon={<LocalFireDepartmentIcon sx={styles.whatsHotIcon} />}
                            sx={styles.whatsHotButton}
                        >
                            See What's Hot!
                        </Button>
                    </Box>

                    <Box sx={styles.liveIndicator}>
                        <Box sx={styles.liveDot} />
                        Live sync - Google, Apple, Outlook & more
                    </Box>
                </Box>

            </Container>
        </Box>
    );
}

export default Hero;
